import React from 'react';


import infoImg1 from '../../assets/images/contact/2.png'
import infoImg2 from '../../assets/images/contact/3.png'
import infoImg3 from '../../assets/images/contact/4.png'

const ContactInfo = (props) => {
    const { contactBoxClass } = props;

    return (
        <ul className="address-sec">
            <li>
                <em className="icon"><img src={infoImg1} alt="image" /></em>
                <span className="text"><em>Address:</em>Unit No.-331, 3rd Floor, Tower B, Spazedge, Sohna Road, Gurgaon , <br/> Haryana</span>
            </li>
            <li>
                <em className="icon"><img src={infoImg2} alt="image" /></em>
                <span className="text"><em>Contact</em> <a href="tel:8800955000">Mobile:+91 8800955000</a> <a href="mailto:info@ocfit.in">Mail: info@ocfit.in</a></span>
            </li>
            <li>
                <em className="icon"><img src={infoImg3} alt="image" /></em>
                <span className="text"><em>Hour of operation</em> Monday - Friday: 09:00 - 06:00 <br/>Saturday & Sunday: Off</span>
            </li>
        </ul>
    );

}

export default ContactInfo;